import { InfoPage, PageHead, SeoFooter } from '@/components'

const Info = ({ data }) => {
    return (
        <>
            <PageHead meta={data.seo_meta}/>
            <InfoPage title={data.title} content={data.description} />
            {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
        </>
    )
}

Info.getInitialProps = async ({ api }) => {
    const { data } = await api.pageWithSlug('info')()

    return { data: data }
}

export default Info
